/* eslint-disable max-len */
import React from 'react';
import styled, { css } from 'styled-components';
import { Images } from '../../../@resources/img';
import { toRemIfUnspecified } from '../../../CodesForUI';

export type SebastianStance = 'normal' | 'edit' | 'inspect' | 'public' | 'private' | 'teach' | 'dead' | 'snooze' | 'security' | 'confused' | 'sad';
export type SebastianProps = { stance: SebastianStance, size?: any } & React.HTMLProps<HTMLDivElement>;

const regs = ['edit', 'inspect', 'public', 'private', 'teach'];
const alts = ['dead', 'snooze', 'security', 'confused'];
const news = ['sad'];

const infoStyle = css`
    background-image: url(${Images.LogoBlue});
    background-size: 78%;
    background-position: 32% 126%;
    background-repeat: no-repeat;
    transform: scaleX(-1);
`;

const regularStyle = (stance: string) => css`
    background-image: url(${Images.SebSprite});
    background-size: 500% 100%;
    ${stance === 'edit' ? 'background-position: 297% 0%;' : ''}
    ${stance === 'inspect' ? 'background-position: -1.1% 0%;' : ''}
    ${stance === 'public' ? 'background-position: 397.8% 0%;' : ''}
    ${stance === 'private' ? 'background-position: 198.2% 0%;' : ''}
    ${stance === 'teach' ? 'background-position: 100% 0%;' : ''}
`;

const altStyle = (stance: string) => css`
    background-image: url(${Images.SebSpriteAlt});
    background-size: 400% 100%;
    ${stance === 'dead' ? 'background-position: 0% 0%;' : ''};
    ${stance === 'confused' ? 'background-position: 100% 0%;' : ''};
    ${stance === 'security' ? 'background-position: 200% 0%;' : ''};
    ${stance === 'snooze' ? 'background-position: 300% 0%;' : ''};
`;

const newStyle = (stance: string) => css`
    background-image: url(${Images.SebSpriteNew});
    background-size: 100% 100%;
    ${stance === 'sad' ? 'background-position: 0% 0%;' : ''};
`;

const selectStyle = (stance: string) => {
    if (regs.includes(stance)) return regularStyle(stance);
    if (alts.includes(stance)) return altStyle(stance);
    if (news.includes(stance)) return newStyle(stance);
    return infoStyle;
};

export const Sebastian = styled.div<SebastianProps>`
    display: inline-block;
    width: ${p => toRemIfUnspecified(p.size ?? 12)};
    height: ${p => toRemIfUnspecified(p.size ?? 12)};
    ${p => selectStyle(p.stance)}
`;
